import { FC } from 'react'

import { getSnippet } from './newRelicAgentSnippets'

export const NewRelicAgent: FC = () => {
	const snippet = getSnippet()
	return snippet ? (
		<script
			type="text/javascript"
			dangerouslySetInnerHTML={{ __html: snippet }}
		/>
	) : (
		<script type="text/javascript" />
	)
}

// this type defition is taken from @types/new-relic-browser, which Next.js had issues importing
type NewRelicAgent = {
	/**
	 * Identifies a browser error without disrupting your app's operations.
	 *
	 * @param error Provide a meaningful error message that you can use when analyzing data on
	 *   New Relic Browser's JavaScript errors page.
	 * @param customAttributes An object containing name/value pairs representing custom attributes.
	 * @see https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/notice-error
	 */
	noticeError(
		error: Error | string,
		customAttributes?: Record<string, string | number>
	): void

	/**
	 * Captures data as a single log event
	 */
	log(message: string, options?: LogOptions): void

	/**
	 * Reports a Browser PageAction event.
	 */
	addPageAction(
		name: string,
		attributes?: Record<string, string | number>
	): void

	/**
	 * Gets the current distributed trace header value
	 */
	getTraceMetadata(): {
		header: string
		payload: Record<string, unknown>
	}

	/**
	 * New Relic loader configuration
	 */
	loader_config: {
		applicationID: string
	}
}

declare global {
	interface Window {
		newrelic: NewRelicAgent
	}
}

interface LogOptions {
	customAttributes?: Record<string, unknown>
	level?: 'debug' | 'error' | 'info' | 'trace' | 'warn'
}

export const getNewRelicTraceHeaders = (): Record<string, string> => {
	if (typeof window !== 'undefined' && window.newrelic?.getTraceMetadata) {
		const traceMetadata = window.newrelic.getTraceMetadata()

		return {
			traceparent: traceMetadata.header,
			tracestate: JSON.stringify(traceMetadata.payload),
			newrelic: traceMetadata.header,
		}
	}
	return {}
}
